const CheckboxIcon = props => {
  return (
    <svg {...props} xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none">
      <path fillRule="evenodd" clipRule="evenodd" d="M6.55898 1.6665H13.784C16.609 1.6665 18.5007 3.64984 18.5007 6.59984V13.409C18.5007 16.3498 16.609 18.3332 13.784 18.3332H6.55898C3.73398 18.3332 1.83398 16.3498 1.83398 13.409V6.59984C1.83398 3.64984 3.73398 1.6665 6.55898 1.6665ZM9.69232 12.4915L13.6507 8.53317C13.934 8.24984 13.934 7.7915 13.6507 7.49984C13.3673 7.2165 12.9007 7.2165 12.6173 7.49984L9.17565 10.9415L7.71732 9.48317C7.43398 9.19984 6.96732 9.19984 6.68398 9.48317C6.40065 9.7665 6.40065 10.2248 6.68398 10.5165L8.66732 12.4915C8.80898 12.6332 8.99232 12.6998 9.17565 12.6998C9.36732 12.6998 9.55065 12.6332 9.69232 12.4915Z" fill="#4FA778" />
    </svg>
  );
}

export default CheckboxIcon;
